import React from 'react';
// Constants
import { CompanyName } from '../../utils/Constants';
// Data
import {
  forgottenPasswordPageAdditionalMeta,
  forgottenPasswordPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import ForgotPasswordForm from '../../components/forms/ForgotPasswordForm';
import { HelmetItem } from '../../components/utils/HelmetItem';
import FiveStarComponent from '../../components/general/FiveStarComponent';
import SponsorMiniBanner from '../../components/sponsor/SponsorMiniBanner';
import DownloadIconSection from '../../components/general/DownloadIconSection';
import TextLogoSection from '../../components/general/TextLogoSection';
import SideTextComponent from '../../components/general/SideTextComponent';

function ForgettenPasswordPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Forgotten Password'
        desc={`Forgotten your password for your ${CompanyName} account. Request a reset from this page.`}
        additionalMeta={forgottenPasswordPageAdditionalMeta}
        structuredData={forgottenPasswordPageStructuredData}
      />

      <div className='grid min-h-screen lg:h-screen lg:max-h-screen lg:overflow-hidden bg-main-background font-poppins'>
        <div className='grid w-full h-full min-h-screen lg:max-h-screen lg:overflow-hidden bg-colour2 px-1 py-1'>
          <div className='bg-colour3 rounded-2xl px-6 py-6'>
            <div className='relative grid h-full w-full items-center justify-center bg-colour1 rounded-2xl shadow-cardShadow'>
              {/* Skip link */}
              <a
                href='#main-content'
                className='sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 bg-colour1 rounded-md px-3 py-2 shadow'
              >
                Skip to main content
              </a>

              {/* Side text */}
              <SideTextComponent />
              {/* Logo */}
              <TextLogoSection />
              {/* Download icons */}
              <DownloadIconSection />
              {/* Sponsor */}
              <SponsorMiniBanner />
              {/* 5 stars */}
              <FiveStarComponent />

              <main
                id='main-content'
                className='grid w-full h-full overflow-hidden'
              >
                <div className='grid w-full h-full justify-center items-center p-2 overflow-hidden'>
                  <section
                    className='grid border-2 border-colour3 dark:border-colour1 border-solid rounded-xl shadow-2xl bg-colour1 dark:bg-colour2'
                    aria-labelledby='forgotten-password-heading'
                  >
                    <div className='grid grid-rows-reg gap-y-8 w-full h-full px-8 py-6'>
                      <header className='grid text-center'>
                        <h1
                          id='forgotten-password-heading'
                          className='text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-colour1'
                        >
                          Forgotten your password
                        </h1>
                      </header>

                      <ForgotPasswordForm />
                    </div>
                  </section>
                </div>
              </main>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgettenPasswordPage;
